module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.mainTag, {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: (_vm.handleVisibilityChange),
      expression: "handleVisibilityChange"
    }],
    tag: "component",
    staticClass: "virtual-scroller",
    class: _vm.cssClass,
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [_vm._t("before-container"), _vm._v(" "), _c(_vm.containerTag, {
    ref: "itemContainer",
    tag: "component",
    staticClass: "item-container",
    class: _vm.containerClass,
    style: (_vm.itemContainerStyle)
  }, [_c('div', {
    ref: "beforeContent"
  }, [_vm._t("before-content")], 2), _vm._v(" "), _c(_vm.contentTag, {
    ref: "items",
    tag: "component",
    staticClass: "items",
    class: _vm.contentClass,
    style: (_vm.itemsStyle)
  }, [(_vm.renderers) ? _vm._l((_vm.visibleItems), function(item, index) {
    return _c(_vm.renderers[item[_vm.typeField]], {
      key: _vm.keysEnabled && item[_vm.keyField] || undefined,
      tag: "component",
      staticClass: "item",
      attrs: {
        "item": item,
        "item-index": _vm.$_startIndex + index
      }
    })
  }) : [_vm._l((_vm.visibleItems), function(item, index) {
    return _vm._t("default", null, {
      item: item,
      itemIndex: _vm.$_startIndex + index,
      itemKey: _vm.keysEnabled && item[_vm.keyField] || undefined
    })
  })]], 2), _vm._v(" "), _vm._t("after-content")], 2), _vm._v(" "), _vm._t("after-container"), _vm._v(" "), _c('resize-observer', {
    on: {
      "notify": _vm.handleResize
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f63ac52"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-virtual-scroller/src/components/VirtualScroller.vue
// module id = 371
// module chunks = 2